import {
  IsArray,
  IsDefined,
  IsInt,
  IsObject,
  IsOptional,
} from "class-validator";

export class GridSchemaDto {
  id: number;

  @IsInt()
  @IsOptional()
  companyId?: number;

  @IsInt()
  entityId: number;

  @IsDefined()
  @IsArray()
  @IsOptional()
  columns?: number[];

  @IsDefined()
  @IsArray()
  @IsOptional()
  columnsOrder?: number[];

  @IsDefined()
  @IsObject()
  @IsOptional()
  columnsVisibility?: object;

  @IsDefined()
  @IsArray()
  @IsOptional()
  groupBy?: number[];

  @IsDefined()
  @IsArray()
  @IsOptional()
  sortBy?: number[];
}
